import React, { useState, useEffect } from 'react'
import PortfolioListItem from './PortfolioListItem'

export default function PortfolioList({
    title, // will be used for the container title
    data, // the data that will be mapped to jsx elements to be displayed
    alignment, // define the layout of the elements
    style // defines the colour scheme for the page
}) {

    // using React.useState we can set the search term from the user for searching 
    // the list items, title, subtitle or content with a default of empty string
    // using the variable displayedData we can return the searcehd data without 
    // destroying the original data
    const [searchTerm, setSearchTerm] = useState('')
    const [displayedData, setDisplayedData] = useState(data)

    // same as above using useState we will create a sort menu that will
    // have various options ticked depandant on properties existing
    const [sortMenu, setSortMenu] = useState('')

    // useEffect to track weather the user is searching an item and will return the appropriate
    // data that matches the title, subtitle or content
    useEffect(() => {
        // run this only if we have data
        if (data) {
            setDisplayedData(data.filter(item => {
                // search if we have a title that matches the search term by checking if the
                // title (in lowercase) matches the serach term (also in lowercase and trimmed whitespace)
                const titleSearch = item?.title.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase().trim())
                // check if we have a subtitle and add that to the search, same for content
                const subtitleSearch = (item.subtitle)
                    ? item?.subtitle.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase().trim())
                    : null

                const contentSearch = (item.content)
                    ? item?.content.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase().trim())
                    : null

                const typeSearch = (item.type)
                    ? item?.type.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase().trim())
                    : null

                // return one of the searches
                return titleSearch || subtitleSearch || contentSearch || typeSearch
            }))
        }
    }, [searchTerm, setDisplayedData, data]) // using searchTerm as the depandancy to rerun when changed

    // If we have no data lets return an empty container
    if (!data || !displayedData) {
        return <div className='empty-container'>{title} No items here</div>
    }

    // function to map the data to jsx elements using the PortfolioListItem with the key
    // being its index position in the array
    const mapListItems = (item, idx) => <PortfolioListItem {...item} key={idx} />

    // sort the data alphabetically using title for now
    // if .date exist then sort by date descending
    // if .type exist then primary sort by type then by alphabetically or date
    const sortListItems = (a, b) => {
        // first check if the property exist and then store the comparison if it does
        // since title is always set we can skip checking if it exists
        const titleComparison = a.title.localeCompare(b.title)
        const typeComparison = a.hasOwnProperty('type')
            ? a.type.localeCompare(b.type)
            : null
        const dateComparison = a.hasOwnProperty('date')
            ? new Date(a.date) - new Date(b.date)
            : null

        // check if values are set in the sort menu
        if (sortMenu === 'date') return dateComparison
        if (sortMenu === 'type') return typeComparison
        if (sortMenu === 'title') return titleComparison

        // return group sort if none of the above are selected
        return typeComparison || dateComparison || titleComparison
    }

    // a callback function to change the sort menu depandant on which button
    // the user clicks (the ev.target.value)
    const handleSortChange = ev => {
        setSortMenu(ev.target.value)
    }

    // a function to make a radio button based on the property type
    const createSortRadioButton = (name) => (
        <label className="radio">
            <input type="radio" name="sort" value={name.toLocaleLowerCase()} onChange={handleSortChange} />
            {name}
        </label>
    )

    // now for each property we want to sort by check if we have it then create the button
    const sortButtons = [
        createSortRadioButton('All'),
        createSortRadioButton('Title')
    ]

    if (data[0]?.type) sortButtons.push(createSortRadioButton('Type'))
    if (data[0]?.date) sortButtons.push(createSortRadioButton('Date'))

    // map the data to the jsx elements after sorting using the functions defined above
    const elements = (displayedData.length > 0)
        ? displayedData.sort(sortListItems).map(mapListItems)
        : <div className="content"><div className="title">The Search returned 0 results</div></div>

    /* if we have more than 6 entries return the search buttons */
    const sortForm = (data.length >= 6)
        ? (
            <div className="field">
                <div className=" has-text-centered"><small>Sort by:</small></div>
                <div className="control">
                    {sortButtons}
                </div>
            </div>
        )
        : null

    // return a container holding our elements
    return <div className="PortfolioList">
        {/* The input will contain the search term and will set the searchTerm onChange */}
        <div className="column is-12 center-items is-flex is-flex-direction-column" id="search-form">
            <div className="field">
                <p className="control has-icons-left">
                    <input type="text" className="search-bar input Rounded" value={searchTerm} onChange={ev => setSearchTerm(ev.target.value)} placeholder="Search" />
                    <span className="icon is-left"><i className="fas fa-search"></i></span>
                </p>
            </div>
            {sortForm}
            <div className="subtitle has-text-centered"><small>results: {displayedData.length}</small></div>

        </div>

        {/* The cards of portfolio list items */}
        <div className={`card-container`}>{elements}</div>
    </div>

    // return (
    //     <div className="container is-centered">
    //         <div className={`card-container`}>{elements}</div>
    //     </div>
    // )

}
